import React from 'react';
import { Form, Input, InputNumber } from 'antd';
const { Group } = Input;
// onChange={e => handleFilterPassengers(e, 'passengers_min')}
// onChange={e => handleFilterPassengers(e, 'passengers_max')}
const Passengers = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Количество пассажиров:" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('passengersMin')(
          <InputNumber
            style={{ width: '50%' }}
            name="passengersMin"
            placeholder="от"
            min={1}
          />
        )}
        {getFieldDecorator('passengersMax')(
          <InputNumber
            style={{ width: '50%' }}
            name="passengersMax"
            placeholder="до"
            min={1}
          />
        )}
      </Group>
    </Form.Item>
  );
};

export default Passengers;
